"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ExpansionPanelSummary = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _excluded = ["children"];

var ExpansionPanelSummary = function ExpansionPanelSummary(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_core.ExpansionPanelSummary, (0, _extends2["default"])({}, props, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }), children);
};

exports.ExpansionPanelSummary = ExpansionPanelSummary;
ExpansionPanelSummary.propTypes = {
  /** The content of the component */
  children: _propTypes["default"].node.isRequired
};
var _default = ExpansionPanelSummary;
exports["default"] = _default;